import React, { useRef } from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import * as i18n from "util/i18n";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { actions as debinActions } from "reducers/debin";
import GridTable from "pages/_components/GridTable/GridTable";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import TextField from "pages/_components/fields/TextField";
import { store } from "store";
import { selectors as sessionSelectors } from "reducers/session";
import SummaryBody from "./components/SummaryBody";

const ChargeBackSummaryPage = () => {
    const FORM_ID = "debin.chargeBack";

    const formRef = useRef(null);

    const { debinToChargeBack, debinTicket } = useSelector((state) => state.debin);

    const activeEnv = sessionSelectors.getActiveEnvironment(store.getState());

    useConfirmTransaction(debinToChargeBack, debinTicket, "debin/chargeBack");

    const data = {
        sellerName: debinToChargeBack?.sellerName,
        debitAccountMask: debinToChargeBack?.debitAccountMask,
        quantity: debinToChargeBack?.quantity,
        currency: debinToChargeBack?.currency,
        issuedDate: debinToChargeBack?.issuedDate,
        expirationDate: debinToChargeBack?.expirationDate,
        debinId: debinToChargeBack?.debinId,
        sellerCbu: debinToChargeBack?.sellerCbu,
        sellerAlias: debinToChargeBack?.sellerAlias,
        sellerBank: debinToChargeBack?.sellerBank,
        sellerBranch: debinToChargeBack?.sellerBranch,
        concept: debinToChargeBack?.concept,
        quote: debinToChargeBack?.quote,
        reference: debinToChargeBack?.reference,
        // para que aparezca el valor en la lista de trx
        amount: {
            currency: debinToChargeBack?.currency,
            quantity: debinToChargeBack?.quantity,
        },
        // para el beneficiario y avatar
        envName: activeEnv?.name,
        type: debinToChargeBack?.type,
        ...debinToChargeBack,
    };

    const maxLength = debinToChargeBack?.isTRXPL ? 500 : 22;
    const maxLengthValidationMsg = i18n.get(`${FORM_ID}.reason.maxLength`, `Máximo ${maxLength} caracteres`);

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        ref: formRef,
        initialValues: {
            reason: "",
        },
        validationSchema: Yup.lazy((values) =>
            Yup.object().shape({
                reason: Yup.string().max(maxLength, maxLengthValidationMsg),
            }),
        ),
    };
    return (
        <>
            <Notification scopeToShow="/debin/chargeBack" />
            <ResponsiveHeader id={i18n.get(`${FORM_ID}.title`)} defaultTitle="Solicitar Contracargo" />
            <MainContainer className="afip-payment-details-list">
                <div className="container">
                    <h2 className="text-lead afip-title-detail">
                        {i18n.get(`${FORM_ID}.subtitle`, "Confirmá transacción")}
                    </h2>
                    <div className="ticket">
                        <div className="ticket__wrapper">
                            <div className="ticket__header" />
                            <SummaryBody
                                sellerName={debinToChargeBack?.sellerName}
                                debitAccountMask={debinToChargeBack?.debitAccountMask}
                                quantity={debinToChargeBack?.quantity}
                                currency={debinToChargeBack?.currency}
                                issuedDate={debinToChargeBack?.issuedDate}
                                expirationDate={debinToChargeBack?.expirationDate}
                                debinId={debinToChargeBack?.debinId}
                                sellerCbu={debinToChargeBack?.sellerCbu}
                                sellerAlias={debinToChargeBack?.sellerAlias}
                                sellerBank={debinToChargeBack?.sellerBank}
                                sellerBranch={debinToChargeBack?.sellerBranch}
                                concept={debinToChargeBack?.concept}
                                quote={debinToChargeBack?.quote}
                                reference={debinToChargeBack?.reference}
                            />
                            <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                        </div>
                    </div>

                    <Formik {...formikProps}>
                        {(allFormik) => (
                            <>
                                <Form
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className="above-the-fold">
                                    <GridTable className="details box box-shadow mt-6">
                                        <GridTable.Container className="gap-6" columns="6" columnsTemplate="fixed">
                                            <GridTable.Data columnStart={1} columnWidth={6}>
                                                <Field
                                                    component={TextField}
                                                    idForm={FORM_ID}
                                                    name="reason"
                                                    maxLength={maxLength}
                                                    labelTextDefault={i18n.get(`${FORM_ID}.reason`, "Motivo")}
                                                    placeholder={i18n.get(
                                                        `${FORM_ID}.reason.placeHolder`,
                                                        "Ingresá el motivo del contracargo",
                                                    )}
                                                />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    </GridTable>
                                </Form>

                                <GeneralCredentialForm
                                    transactionData={{ ...data, reason: allFormik.values.reason }}
                                    action={
                                        debinToChargeBack?.isTRXPL
                                            ? debinActions.chargeBackSendTrxPl
                                            : debinActions.chargeBackSend
                                    }
                                    idActivity="load.debin.recurrency"
                                    hideIndications
                                />
                            </>
                        )}
                    </Formik>
                </div>
            </MainContainer>
        </>
    );
};

export default ChargeBackSummaryPage;
